<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-main-sidebar></app-main-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar =  !isSidebar"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="col-sm-12">
            <div class="row dblock">
              <!-- style="padding: 5px;box-shadow: 0 0 15px 0 rgba(0,0,0,.05);" -->
              <div class="row">
                <div class="col-sm-12">
                  <vs-breadcrumb
                    align="left"
                    :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Trainer/trainerDashboard',
                    }
                    ,{
                      title: 'Profile Settings',
                      url: '/#/dashboard/Trainer/Trainer_Registration_Form',
                       active: true
                    }
                  ]"
                  ></vs-breadcrumb>
                  <div class="heading mt-3">
                    <h3 class="text-secondary">TRAINER REGISTRATION FORM</h3>
                  </div>
                </div>
              </div>
              <!-- ======================= -->
              <!-- tabs starts -->
              <form
                @submit.prevent="trainerRegistration"
                enctype="multipart/form-data"
              >
                <div>
                  <vs-tabs
                    v-model="tabIndex"
                    alignment="fixed"
                    :color="colorx='rgba(7, 167, 225, 0.61)'"
                  >
                    <vs-tab
                      icon="person"
                      @click="colorx = 'rgba(7, 167, 225, 0.61)'"
                      label="Basic Information"
                      style="margin-top:20px;display:block !important;"
                    >
                      <div class="con-tab-ejemplo pt-3">
                        <!-- Basic Information starts -->
                        <div class="form-group form-row">
                          <h6 class="sub-frm-title">Basic Information</h6>
                          <!-- floating input starts -->
                          <div class="col-sm-12">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="name"
                                type="text"
                                placeholder=" "
                              />
                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >account_circle</i
                                >
                              </span>
                              <label class="lbl-label">
                                Full Name
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                            </div>
                          </div>
                          <!-- floating input ends -->

                          <!-- <vs-select
                            class="col-sm-6 mt-3"
                            style="width:100%;"
                            label="Select Identity"
                            v-model="whichSelect"
                          >
                            <vs-select-item
                              :key="index"
                              :value="item.value"
                              :text="item.text"
                              v-for="(item,index) in options1"
                            />
                          </vs-select>-->
                          <!--  v-if="whichSelect === 0" -->
                          <div class="col-sm-6 mt-4">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="passport"
                                type="text"
                                placeholder=" "
                              />
                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >credit_card</i
                                >
                              </span>
                              <label class="lbl-label">
                                Passport
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                            </div>
                          </div>
                          <!--  v-if="whichSelect === 1" -->
                          <div class="col-sm-6 mt-4">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-mask="'(99999) 9999999-9'"
                                v-model="cnincnumber"
                                type="text"
                                placeholder=" "
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >credit_card</i
                                >
                              </span>
                              <label class="lbl-label">
                                CNIC Number
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                            </div>
                          </div>

                          <!-- Gender starts -->

                          <div
                            class="col-sm-12 mt-4"
                            style="color: #07a7e19c !important;"
                          >
                            <div class="row">
                              <label class="col-sm-2 col-md-2 col-lg-2">
                                <b>Gender</b>
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                              <div class="col-sm-2 col-md-2 col-lg-2">
                                <vs-radio
                                  v-model="gender"
                                  vs-name="radios1"
                                  vs-value="male"
                                  class="text-dark"
                                  >Male</vs-radio
                                >
                              </div>
                              <div class="col-sm-2 col-md-2 col-lg-2">
                                <vs-radio
                                  v-model="gender"
                                  vs-name="radios1"
                                  vs-value="female"
                                  class="text-dark"
                                  >Female</vs-radio
                                >
                              </div>
                              <div class="col-sm-4 col-md-4 col-lg-3">
                                <vs-radio
                                  v-model="gender"
                                  vs-name="radios1"
                                  vs-value="rather not say"
                                  class="text-dark"
                                  >Rather not say</vs-radio
                                >
                              </div>
                            </div>
                          </div>
                          <!-- Gender ends -->
                          <!-- language skills starts -->
                          <template v-for="(item,index) in languagerowArr">
                            <div
                              class="row mt-3"
                              style="width:100%"
                              v-bind:key="index"
                            >
                              <div class="row col-sm-12">
                                <div class="col-sm-3 mt-2">
                                  <!-- <ul class="centerx" style="display: inline-flex;list-style: none;">
                                  <li class="col-sm-4" style="display:inline-flex;">-->
                                  <label
                                    style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;"
                                  >
                                    Select language
                                    <span style="color:rgba(255, 0, 0, 0.78);"
                                      >*</span
                                    >
                                  </label>
                                  <selectize
                                    style="width:100%;"
                                    id="select-state"
                                    v-model="item.lang"
                                    :settings="languageSetting"
                                    :searchable="true"
                                  >
                                    <option
                                      v-for="(item,index) in languageskillsArr"
                                      :key="index"
                                      :value="item.title"
                                      :text="item.title"
                                    >
                                      {{item.title}}
                                    </option>
                                  </selectize>
                                </div>
                                <div class="col-sm-3 mt-2">
                                  <label
                                    style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;"
                                  >
                                    Select read level
                                    <span style="color:rgba(255, 0, 0, 0.78);"
                                      >*</span
                                    >
                                  </label>
                                  <selectize
                                    style="width:100%;"
                                    id="select-state"
                                    v-model="item.readlevel"
                                    :settings="levelSetting"
                                    :searchable="true"
                                  >
                                    <option
                                      v-for="(item,index) in selectlevelArr"
                                      :key="index"
                                      :value="item.value"
                                      :text="item.text"
                                    >
                                      {{item.text}}
                                    </option>
                                  </selectize>
                                </div>
                                <div class="col-sm-3 mt-2">
                                  <label
                                    style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;"
                                  >
                                    Select write level
                                    <span style="color:rgba(255, 0, 0, 0.78);"
                                      >*</span
                                    >
                                  </label>
                                  <selectize
                                    style="width:100%;"
                                    label="Country"
                                    id="select-state"
                                    v-model="item.writelevel"
                                    :settings="writeSetting"
                                    :searchable="true"
                                  >
                                    <option
                                      v-for="(item,index) in selectlevelArr"
                                      :key="index"
                                      :value="item.value"
                                      :text="item.text"
                                    >
                                      {{item.text}}
                                    </option>
                                  </selectize>
                                </div>
                                <div class="col-sm-3 mt-2">
                                  <label
                                    style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;"
                                  >
                                    Select Speak Level
                                    <span style="color:rgba(255, 0, 0, 0.78);"
                                      >*</span
                                    >
                                  </label>
                                  <selectize
                                    style="width:100%;"
                                    label="Country"
                                    id="select-state"
                                    v-model="item.speaklevel"
                                    :settings="speakSetting"
                                    :searchable="true"
                                  >
                                    <option
                                      v-for="(item,index) in selectlevelArr"
                                      :key="index"
                                      :value="item.value"
                                      :text="item.text"
                                    >
                                      {{item.text}}
                                    </option>
                                  </selectize>
                                  <template v-if="index === 0">
                                    <span @click="addlanguageRows()">
                                      <vs-icon
                                        icon="add_box"
                                        class="add-btn"
                                        style="float: right;
                                        margin-right: -40px;
                                        margin-top: -33px;"
                                      ></vs-icon>
                                    </span>
                                    <!-- <b-button class="add-btn" @click="addRows()" variant="primary">Add</b-button> -->
                                  </template>
                                  <template v-else>
                                    <span @click="removelanguageRow()">
                                      <vs-icon
                                        icon="delete_forever"
                                        class="delete-btn"
                                        style="float: right;
                                        margin-right: -40px;
                                        margin-top: -33px;"
                                      ></vs-icon>
                                    </span>
                                    <!-- <button class="btn btn-danger" @click="removeRow()">Delete</button> -->
                                  </template>
                                </div>
                              </div>
                            </div>
                          </template>
                          <!-- language skills ends -->
                          <!-- other skills starts -->
                          <!-- <div class="row mt-3" style="width:100%"> -->
                          <div class="col-sm-6 mt-4">
                            <label
                              style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;"
                            >
                              Thematic Area / Outcome
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>

                            <selectize
                              id="select-state"
                              v-model="thematicareaSelected"
                              :settings="thematicareasettings"
                            >
                              <option
                                v-for="(item,index) in valuesArray"
                                :key="index"
                                :value="item.id"
                              >
                                {{item.name}}
                              </option>
                            </selectize>
                          </div>
                          <div class="col-sm-6 mt-4">
                            <label style="color: #07a7e19c !important;">
                              Add Skills
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>
                            <vue-tags-input
                              style="max-width:100%;"
                              v-model="tag"
                              :tags="tags"
                              placeholder
                              @tags-changed="newTags => tags = newTags"
                            />
                          </div>
                          <!-- </div> -->
                          <!-- other skills ends -->

                          <!-- Address starts -->
                          <!-- <div class="row"> -->
                          <div class="col-sm-6 mt-4">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                type="text"
                                v-model="mobilenumber"
                                v-mask="'(9999) 9999999'"
                                placeholder
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >local_phone</i
                                >
                              </span>
                              <label class="lbl-label">
                                Mobile Number
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                            </div>
                          </div>
                          <div class="col-sm-6 mt-4">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                type="text"
                                v-model="emailaddress"
                                placeholder
                                readonly="readonly"
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >email</i
                                >
                              </span>
                              <label class="lbl-label">
                                Email
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                            </div>
                          </div>

                          <!-- <div class="col-sm-4 mt-4">
                              <label style="color: #07a7e19c !important;">
                                Country
                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                              </label>
                              <selectize
                                style="width:100%;"
                                v-if="countryArr"
                                label="Country"
                                id="select-state"
                                v-model="nationality"
                                :settings="countrySetting"
                                :searchable="true"
                              >
                                <option
                                  v-for="(item,index) in countryArr"
                                  :key="index"
                                  :value="item.id"
                                  :text="item.title"
                                >{{item.title}}</option>
                              </selectize>
                          </div>-->

                          <!-- <div class="col-sm-4 mt-4">
                              <label style="color: #07a7e19c !important;">
                                Province
                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                              </label>
                              <selectize
                                style="width:100%;"
                                v-if="countryArr"
                                label="Country"
                                id="select-state"
                                v-model="province"
                                :settings="provinceSetting"
                                :searchable="true"
                              >
                                <option
                                  v-for="(item,index) in provinceArr"
                                  :key="index"
                                  :value="item.id"
                                  :text="item.title"
                                >{{item.title}}</option>
                              </selectize>
                          </div>-->

                          <div class="col-sm-12 mt-4">
                            <label style="color: #07a7e19c !important;">
                              District
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>
                            <selectize
                              style="width:100%;"
                              v-if="countryArr"
                              label="Country"
                              id="select-state"
                              v-model="distrct"
                              :settings="districtSetting"
                              :searchable="true"
                            >
                              <option
                                v-for="(item,index) in districtArr"
                                :key="index"
                                :value="item.id"
                                :text="item.title"
                              >
                                {{item.title}}, {{item.province.title}},
                                {{item.province.country.title}}
                              </option>
                            </selectize>
                          </div>
                          <!-- floating input starts -->
                          <div class="col-sm-12 mt-4">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                type="text"
                                v-model="physicaladdress"
                                placeholder=" "
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >place</i
                                >
                              </span>
                              <label class="lbl-label">
                                Address
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                            </div>
                          </div>
                          <!-- floating input ends -->
                        </div>
                        <!-- Address ends -->
                        <!-- </div> -->
                        <!-- Basic Information ends -->
                      </div>
                      <!-- next button starts-->
                      <b-button
                        @click="tabIndex++"
                        class="save-btn"
                        variant="primary"
                        style="margin-top:100px"
                        >Next</b-button
                      >
                      <!-- next button ends -->
                    </vs-tab>
                    <vs-tab
                      icon="school"
                      @click="colorx = 'rgba(7, 167, 225, 0.61)'"
                      label="Education Information"
                    >
                      <div class="con-tab-ejemplo pt-3">
                        <!--Education Information starts -->
                        <div class="form-group form-row">
                          <h6 class="sub-frm-title">Educational Information</h6>
                          <!-- Accademic Qualification starts -->
                          <div class="col-sm-12">
                            <h6 style="color:#212529;font-size:15px;">
                              Accademic Qualification
                            </h6>
                            <div class="table-responsive-sm">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th
                                      scope="col"
                                      style="color: #07a7e19c !important;"
                                    >
                                      Degree Name
                                      <span style="color:rgba(255, 0, 0, 0.78);"
                                        >*</span
                                      >
                                    </th>
                                    <th
                                      scope="col"
                                      style="color: #07a7e19c !important;"
                                    >
                                      Degree Subject
                                      <span style="color:rgba(255, 0, 0, 0.78);"
                                        >*</span
                                      >
                                    </th>
                                    <!-- <th scope="col">Department / Organization</th> -->
                                    <th
                                      scope="col"
                                      style="color: #07a7e19c !important;"
                                    >
                                      University / Institue / School
                                      <span style="color:rgba(255, 0, 0, 0.78);"
                                        >*</span
                                      >
                                    </th>
                                    <th scope="col"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <template
                                    v-for="(item,index) in accademicArr"
                                  >
                                    <tr v-bind:key="index">
                                      <td>
                                        <div>
                                          <input
                                            style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                            type="text"
                                            class="form-control"
                                            v-model="item.degreename"
                                            id="inputtext"
                                            placeholder
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          <input
                                            style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                            type="text"
                                            class="form-control"
                                            v-model="item.degreesubject"
                                            id="inputtext"
                                            placeholder
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          <input
                                            style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                            type="text"
                                            class="form-control"
                                            id="inputtext"
                                            v-model="item.univeristyName"
                                            placeholder
                                          />
                                        </div>
                                      </td>
                                      <td style="vertical-align: middle;">
                                        <div>
                                          <template v-if="index === 0">
                                            <span @click="addaccademicRows()">
                                              <vs-icon
                                                icon="add_box"
                                                class="add-btn"
                                              ></vs-icon>
                                            </span>
                                            <!-- <b-button class="add-btn" @click="addRows()" variant="primary">Add</b-button> -->
                                          </template>
                                          <template v-else>
                                            <span @click="removeaccademicRow()">
                                              <vs-icon
                                                icon="delete_forever"
                                                class="delete-btn"
                                              ></vs-icon>
                                            </span>
                                            <!-- <button class="btn btn-danger" @click="removeRow()">Delete</button> -->
                                          </template>
                                        </div>
                                      </td>
                                    </tr>
                                  </template>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <!-- Accademic Qualification ends -->
                          <!-- ============================== -->
                          <!-- Additional Certificates starts -->
                          <div class="col-sm-12">
                            <h6 style="color:#212529;font-size:15px;">
                              Additional Certificates
                            </h6>
                            <div class="table-responsive-sm">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th
                                      scope="col"
                                      style="color: #07a7e19c !important;"
                                    >
                                      Certificate Name
                                      <span style="color:rgba(255, 0, 0, 0.78);"
                                        >*</span
                                      >
                                    </th>
                                    <th
                                      scope="col"
                                      style="color: #07a7e19c !important;"
                                    >
                                      Completion Year
                                      <span style="color:rgba(255, 0, 0, 0.78);"
                                        >*</span
                                      >
                                    </th>
                                    <!-- <th scope="col">Department / Organization</th> -->
                                    <th
                                      scope="col"
                                      style="color: #07a7e19c !important;"
                                    >
                                      University / Institue / School
                                      <span style="color:rgba(255, 0, 0, 0.78);"
                                        >*</span
                                      >
                                    </th>
                                    <th scope="col"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <template
                                    v-for="(item,index) in certificateArr"
                                  >
                                    <tr v-bind:key="index">
                                      <td>
                                        <div>
                                          <input
                                            style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                            type="text"
                                            class="form-control"
                                            v-model="item.certificateName"
                                            id="inputtext"
                                            placeholder
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          <input
                                            style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                            type="text"
                                            v-mask="'9999'"
                                            class="form-control"
                                            v-model="item.certificateYear"
                                            id="inputtext"
                                            placeholder
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          <input
                                            style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                            type="text"
                                            class="form-control"
                                            v-model="item.certificateInstitute"
                                            id="inputtext"
                                            placeholder
                                          />
                                        </div>
                                      </td>
                                      <td style="vertical-align: middle;">
                                        <div>
                                          <template v-if="index === 0">
                                            <span @click="addcertificateRows()">
                                              <vs-icon
                                                icon="add_box"
                                                class="add-btn"
                                              ></vs-icon>
                                            </span>
                                            <!-- <b-button class="add-btn" @click="addRows()" variant="primary">Add</b-button> -->
                                          </template>
                                          <template v-else>
                                            <span
                                              @click="removecertificateRow()"
                                            >
                                              <vs-icon
                                                icon="delete_forever"
                                                class="delete-btn"
                                              ></vs-icon>
                                            </span>
                                            <!-- <button class="btn btn-danger" @click="removeRow()">Delete</button> -->
                                          </template>
                                        </div>
                                      </td>
                                    </tr>
                                  </template>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <!-- Additional Certificates ends -->
                        </div>
                        <!--Education Information ends -->
                      </div>
                      <!-- next button starts-->
                      <b-button
                        @click="tabIndex++"
                        class="save-btn"
                        variant="primary"
                        >Next</b-button
                      >
                      <!-- next button ends -->
                      <!-- next button starts-->
                      <b-button
                        @click="tabIndex--"
                        class="previous-btn"
                        variant="primary"
                        >Previous</b-button
                      >
                      <!-- next button ends -->
                    </vs-tab>
                    <vs-tab
                      icon="business_center"
                      @click="colorx = 'rgba(7, 167, 225, 0.61)'"
                      label="Employment Record"
                      style="    height: 500px;"
                    >
                      <div class="con-tab-ejemplo pt-3">
                        <!--Employment Record Information starts -->
                        <div class="form-group form-row">
                          <h6 class="sub-frm-title">
                            Employment Record Information
                          </h6>
                          <!-- Employment Record starts -->
                          <div class="col-sm-12">
                            <!-- <h6 style="color:#212529;font-size:15px;">Employment Record</h6> -->
                            <!-- <div class="table-responsive-sm">
                              <table class="table">
                                <thead>
                                  <tr>
                                   <th scope="col" style="color: #07a7e19c !important;">
                                      Organization
                                      <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                    </th>
                                    <th scope="col" style="color: #07a7e19c !important;">
                                      Designation
                                      <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                    </th>
                                    <th scope="col" style="color: #07a7e19c !important;">
                                      From (Date)
                                      <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                    </th>
                                    <th scope="col" style="color: #07a7e19c !important;">
                                      To (Date)
                                      <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                    </th>
                                    <th scope="col"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <template v-for="(item,index) in employeerecordArr">
                                    <tr v-bind:key="index">
                                      <td>
                                        <div>
                                          <input
                                            style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                            type="text"
                                            class="form-control"
                                            v-model="item.emp_organization"
                                            id="inputtext"
                                            placeholder
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          <input
                                            style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                            type="text"
                                            class="form-control"
                                            id="inputtext"
                                            v-model="item.emp_designation"
                                            placeholder
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div class="col-sm-12">
                                          
                                          <flat-pickr
                                            class="form-control"
                                            style="background: #fff"
                                            placeholder="Select start date"
                                            v-model="item.emp_fromDate"
                                            :config="optionsdate"
                                          ></flat-pickr>
                                        </div>
                                      </td>
                                      <td>
                                        <flat-pickr
                                            class="form-control"
                                            style="background: #fff"
                                            placeholder="Select start date"
                                            v-model="item.emp_endDate"
                                            :config="optionsdate"
                                          ></flat-pickr>
                                      </td>

                                      <td style="vertical-align: middle;">
                                        <div>
                                          <template v-if="index === 0">
                                            <span @click="addemployeerecordRows()">
                                              <vs-icon icon="add_box" class="add-btn"></vs-icon>
                                            </span>
                                          </template>
                                          <template v-else>
                                            <span @click="removeemployeerecordRow()">
                                              <vs-icon icon="delete_forever" class="delete-btn"></vs-icon>
                                            </span>
                                          </template>
                                        </div>
                                      </td>
                                    </tr>
                                  </template>
                                </tbody>
                              </table>
                            </div>-->
                          </div>

                          <div
                            class="row col-sm-12"
                            v-for="(item,index) in employeerecordArr"
                            v-bind:key="index"
                          >
                            <div class="col-sm-3 mt-2">
                              <label
                                style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;"
                                >Organization</label
                              >
                              <input
                                style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                type="text"
                                class="form-control"
                                v-model="item.emp_organization"
                                id="inputtext"
                                placeholder
                              />
                            </div>
                            <div class="col-sm-3 mt-2">
                              <label
                                style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;"
                                >Designation</label
                              >
                              <input
                                style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                type="text"
                                class="form-control"
                                id="inputtext"
                                v-model="item.emp_designation"
                                placeholder
                              />
                            </div>
                            <div class="col-sm-3 mt-2">
                              <label
                                style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;"
                                >From (Date)</label
                              >
                              <flat-pickr
                                class="form-control"
                                style="background: #fff"
                                placeholder
                                v-model="item.emp_fromDate"
                                :config="optionsdate"
                              ></flat-pickr>
                            </div>
                            <div class="col-sm-3 mt-2">
                              <label
                                style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;"
                                >To (Date)</label
                              >
                              <flat-pickr
                                class="form-control"
                                style="background: #fff"
                                placeholder
                                v-model="item.emp_endDate"
                                :config="optionsdate"
                              ></flat-pickr>
                              <div
                                style="margin-top:-33px;float:right;margin-right:-35px"
                              >
                                <div v-if="index === 0">
                                  <vs-icon
                                    @click="addemployeerecordRows()"
                                    icon="add_box"
                                    class="add-btn"
                                  ></vs-icon>
                                </div>
                                <div v-else>
                                  <vs-icon
                                    @click="removeemployeerecordRow()"
                                    icon="delete_forever"
                                    class="delete-btn"
                                  ></vs-icon>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Employment Record ends -->
                        </div>
                        <!--Employment Record Information ends -->
                      </div>
                      <!-- next button starts-->
                      <b-button
                        @click="tabIndex++"
                        class="save-btn"
                        variant="primary"
                        >Next</b-button
                      >
                      <!-- next button ends -->
                      <!-- next button starts-->
                      <b-button
                        @click="tabIndex--"
                        class="previous-btn"
                        variant="primary"
                        >Previous</b-button
                      >
                      <!-- next button ends -->
                    </vs-tab>
                    <vs-tab
                      icon="nature_people"
                      @click="colorx = 'rgba(7, 167, 225, 0.61)'"
                      label="Event Information"
                    >
                      <div class="con-tab-ejemplo pt-3">
                        <!--Event Information starts -->
                        <div class="form-group form-row">
                          <h6 class="sub-frm-title">Event Information</h6>
                          <!-- Conducted Trainings for UNODC starts -->
                          <div class="col-sm-12">
                            <h6 style="color:#212529;font-size:15px;">
                              Conducted Trainings for UNODC
                            </h6>
                            <div class="table-responsive-sm">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <!-- <th scope="col">S.No</th> -->
                                    <th
                                      scope="col"
                                      style="color: #07a7e19c !important;"
                                    >
                                      Training Name
                                      <span style="color:rgba(255, 0, 0, 0.78);"
                                        >*</span
                                      >
                                    </th>
                                    <th
                                      scope="col"
                                      style="color: #07a7e19c !important;"
                                    >
                                      Date
                                      <span style="color:rgba(255, 0, 0, 0.78);"
                                        >*</span
                                      >
                                    </th>
                                    <th
                                      scope="col"
                                      style="color: #07a7e19c !important;"
                                    >
                                      For Department
                                      <span style="color:rgba(255, 0, 0, 0.78);"
                                        >*</span
                                      >
                                    </th>
                                    <th scope="col"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <template v-for="(item,index) in unodcrowArr">
                                    <tr v-bind:key="index">
                                      <td>
                                        <div>
                                          <input
                                            style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                            type="text"
                                            class="form-control"
                                            v-model="item.unodcTrainingName"
                                            id="inputtext"
                                            placeholder
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <!-- <div>
                                        <input
                                          style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                          type="text"
                                          v-model="item.unodcDate"
                                          class="form-control"
                                          id="inputtext"
                                          placeholder
                                        />
                                        </div>-->
                                        <div class="col-sm-12">
                                          <date-picker
                                            v-model="item.unodcDate"
                                            :config="optionsdate"
                                          ></date-picker>
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          <input
                                            style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                            type="text"
                                            class="form-control"
                                            id="inputtext"
                                            v-model="item.unodcdepartment"
                                            placeholder
                                          />
                                        </div>
                                      </td>
                                      <td style="vertical-align: middle;">
                                        <div>
                                          <template v-if="index === 0">
                                            <span @click="addunodcRows()">
                                              <vs-icon
                                                icon="add_box"
                                                class="add-btn"
                                              ></vs-icon>
                                            </span>
                                            <!-- <b-button class="add-btn" @click="addRows()" variant="primary">Add</b-button> -->
                                          </template>
                                          <template v-else>
                                            <span @click="removeunodcRow()">
                                              <vs-icon
                                                icon="delete_forever"
                                                class="delete-btn"
                                              ></vs-icon>
                                            </span>
                                            <!-- <button class="btn btn-danger" @click="removeRow()">Delete</button> -->
                                          </template>
                                        </div>
                                      </td>
                                    </tr>
                                  </template>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <!-- Conducted Trainings for UNODC ends -->
                          <!-- ============================== -->
                          <!-- Conducted Trainings for Others starts -->
                          <div class="col-sm-12">
                            <h6 style="color:#212529;font-size:15px;">
                              Conducted Trainings for Others
                            </h6>
                            <div class="table-responsive-sm">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <!-- <th scope="col">S.No</th> -->
                                    <th
                                      scope="col"
                                      style="color: #07a7e19c !important;"
                                    >
                                      Training Name
                                      <span style="color:rgba(255, 0, 0, 0.78);"
                                        >*</span
                                      >
                                    </th>
                                    <th
                                      scope="col"
                                      style="color: #07a7e19c !important;"
                                    >
                                      Date
                                      <span style="color:rgba(255, 0, 0, 0.78);"
                                        >*</span
                                      >
                                    </th>
                                    <th
                                      scope="col"
                                      style="color: #07a7e19c !important;"
                                    >
                                      For Department
                                      <span style="color:rgba(255, 0, 0, 0.78);"
                                        >*</span
                                      >
                                    </th>
                                    <th scope="col"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <template v-for="(item,index) in rowArr">
                                    <tr v-bind:key="index">
                                      <td>
                                        <div>
                                          <input
                                            style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                            type="text"
                                            class="form-control"
                                            id="inputtext"
                                            v-model="item.otherTrainingName"
                                            placeholder
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          <input
                                            style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                            type="text"
                                            class="form-control"
                                            id="inputtext"
                                            v-model="item.otherDate"
                                            placeholder
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          <input
                                            style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                            type="text"
                                            class="form-control"
                                            id="inputtext"
                                            v-model="item.otherdepartment"
                                            placeholder
                                          />
                                        </div>
                                      </td>
                                      <td style="vertical-align: middle;">
                                        <div>
                                          <template v-if="index === 0">
                                            <span @click="addRows()">
                                              <vs-icon
                                                icon="add_box"
                                                class="add-btn"
                                              ></vs-icon>
                                            </span>
                                            <!-- <b-button class="add-btn" @click="addRows()" variant="primary">Add</b-button> -->
                                          </template>
                                          <template v-else>
                                            <span @click="removeRow()">
                                              <vs-icon
                                                icon="delete_forever"
                                                class="delete-btn"
                                              ></vs-icon>
                                            </span>
                                            <!-- <button class="btn btn-danger" @click="removeRow()">Delete</button> -->
                                          </template>
                                        </div>
                                      </td>
                                    </tr>
                                  </template>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <!-- Conducted Trainings for Others ends -->
                        </div>
                        <!--Event Information ends -->
                      </div>
                      <!-- next button starts-->
                      <b-button
                        @click="tabIndex++"
                        class="save-btn"
                        variant="primary"
                        >Next</b-button
                      >
                      <!-- next button ends -->
                      <!-- next button starts-->
                      <b-button
                        @click="tabIndex--"
                        class="previous-btn"
                        variant="primary"
                        >Previous</b-button
                      >
                      <!-- next button ends -->
                    </vs-tab>
                    <vs-tab
                      icon="create_new_folder"
                      @click="colorx = 'rgba(7, 167, 225, 0.61)'"
                      label="Uploads"
                    >
                      <div class="con-tab-ejemplo pt-3">
                        <!--Uploads starts -->
                        <div class="form-group form-row">
                          <h6 class="sub-frm-title">Uploads</h6>

                          <div class="col-sm-12" style="display:inline-flex;">
                            <!-- <div class="centerx col-sm-6" style="display:grid;justify-content:center;">
                        <vs-upload
                          text="Upload CV"
                          action="https://jsonplaceholder.typicode.com/posts/"
                          @on-success="successUpload"
                        />
                            </div>-->
                            <div class="col-sm-6">
                              <!-- <vs-upload
                          text="Upload P11 Form"
                          action="https://jsonplaceholder.typicode.com/posts/"
                          @on-success="successUpload"
                              />-->
                              <div>
                                <b-form-file
                                  v-model="file"
                                  :state="Boolean(file)"
                                  placeholder="Upload P-11 or CV"
                                  drop-placeholder="Drop file here..."
                                ></b-form-file>
                                <div
                                  class="otherMaterial_palceholder"
                                  v-if="uploadfileName !=''"
                                >
                                  {{uploadfileName}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--Uploads ends -->
                      </div>
                      <!-- next button starts-->
                      <b-button class="save-btn" type="submit" variant="primary"
                        >Submit</b-button
                      >
                      <!-- next button ends -->
                      <!-- next button starts-->
                      <b-button
                        @click="tabIndex--"
                        class="previous-btn"
                        variant="primary"
                        >Previous</b-button
                      >
                      <!-- next button ends -->
                    </vs-tab>
                  </vs-tabs>
                </div>
              </form>
              <!-- tabs ends -->
              <!-- ======================= -->

              <!-- save button starts-->
              <!-- <b-button class="save-btn" variant="primary">Save</b-button> -->
              <!-- save button ends -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import mainSidebar from "./main-sidebar";
import Selectize from "vue2-selectize";
import VueTagsInput from "@johmun/vue-tags-input";
import "bootstrap/dist/css/bootstrap.css";
import datePicker from "vue-bootstrap-datetimepicker";

// flatPickr
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import axios from "axios";
export default {
  data: () => ({
    isSidebar: false,
    valuesArray: [],
    // whichSelect: 0,
    // options1: [
    //   { text: "Passport", value: 0 },
    //   { text: "CNIC Number", value: 1 }
    // ],
    gender: "",
    file: "",
    isForm: true,
    isFormData: false,
    rowArr: [{ otherTrainingName: "", otherDate: "", otherdepartment: "" }],
    name: "",
    tabIndex: 0,
    unodcrowArr: [
      { unodcTrainingName: "", unodcDate: "", unodcdepartment: "" }
    ],
    mobilenumber: "",
    employeerecordArr: [
      {
        emp_organization: "",
        emp_designation: "",
        emp_fromDate: "",
        emp_endDate: ""
      }
    ],
    accademicArr: [{ degreename: "", degreesubject: "", univeristyName: "" }],
    emailaddress: "",
    trainingdate: "",
    trainingdepartment: "",
    degreeuniversity: "",
    physicaladdress: "",
    contact_person: "",
    contact_number: "",
    contact_email: "",
    address: "",
    optionsdate: {
      format: "DD/MM/YYYY",
      useCurrent: false
    },
    tag: "",
    tags: [],

    checkBox1: false,
    checkBox2: false,
    checkBox3: false,
    checkBox4: false,
    textarea: "",
    counterDanger: false,
    mydate: "",
    startDate: "",
    Dates: [{ startDate: "", endDate: "" }],
    unodctraining: "",
    passport: "",
    cnincnumber: "",
    certificatename: "",
    certificateyear: "",
    certificateinstitute: "",
    othertrainingname: "",
    othertrainingdate: "",
    othertrainingdepartment: "",
    e_orgainzation: "",
    e_designation: "",
    e_fromDate: "",
    e_toDate: "",
    endDate: "",
    colorx: "#1db952",
    indexActive: 0,
    trainingCheck: false,
    repeatedCheck: false,
    select1Normal: "",
    select1: 0,
    language: 1,
    readlevel: 0,
    phone_no: "",
    writelevel: 1,
    speaklevel: 1,
    select6: 1,
    nationality: 1,
    province: 1,
    distrct: 1,
    select10: 0,
    academicdegreename: 1,
    degreesubject: 1,
    select13: 1,
    dateOptions: {
      wrap: true,
      weekNumbers: true,
      dateFormat: "d-m-Y"
    },
    thematicareaSelected: [],
    uploadfileurl: "",
    uploadfileName: "",
    thematicareasettings: {
      maxItems: 10,
      plugins: ["remove_button"]
    },
    traineridentityArr: [
      { text: "CNIC Number", value: 1 },
      {
        text: "Passport Number",
        value: 2
      }
    ],
    languageskillsArr: [],
    certificateArr: [
      { certificateName: "", certificateYear: "", certificateInstitute: "" }
    ],
    languageSetting: {
      maxItems: 1,
      searchField: ["name"],
      plugins: ["remove_button"]
    },
    levelSetting: {
      maxItems: 1,
      searchField: ["name"],
      plugins: ["remove_button"]
    },
    writeSetting: {
      maxItems: 1,
      searchField: ["name"],
      plugins: ["remove_button"]
    },
    speakSetting: {
      maxItems: 1,
      searchField: ["name"],
      plugins: ["remove_button"]
    },
    countrySetting: {
      // maxItems: 1,
      searchField: ["text"],
      // plugins: ["remove_button"],
      placeholder: "Select country here"
    },
    provinceSetting: {
      // maxItems: 1,
      searchField: ["text"],
      // plugins: ["remove_button"],
      placeholder: "Select province here"
    },
    districtSetting: {
      // maxItems: 1,
      searchField: ["text"],
      // plugins: ["remove_button"],
      placeholder: "Select district here"
    },
    languagerowArr: [
      { lang: "", readlevel: "", writelevel: "", speaklevel: "" }
    ],
    selectlevelArr: [
      { text: "Good", value: "Good" },
      { text: "Very Good", value: "Very Good" },
      { text: "Excellent", value: "Excellent" },
      { text: "Weak", value: "Weak" }
    ],
    userDetails: [],
    countryArr: [],
    provinceArr: [],
    districtArr: [],
    thematicareaArr: [
      { text: "Front-End", value: 1 },
      {
        text: "Back-End",
        value: 2
      },
      {
        text: "Graphics Designing",
        value: 3
      },
      {
        text: "Web Designing",
        value: 4
      }
    ],
    degreenameArr: [
      {
        text: "Ph.D",
        value: 1
      },
      {
        text: "M.Phil",
        value: 2
      },
      { text: "M.A", value: 3 },
      {
        text: "M.Sc",
        value: 4
      },
      {
        text: "B.A",
        value: 5
      },
      {
        text: "B.Sc",
        value: 6
      },
      {
        text: "F.A",
        value: 7
      },
      {
        text: "F.Sc",
        value: 8
      },
      {
        text: "Matric",
        value: 9
      }
    ],
    degreesubjectArr: [
      { text: "Management Science", value: 1 },
      { text: "Computer Science", value: 2 },
      { text: "Software Engineering", value: 3 }
    ],
    // jobnatureArr: [
    //   { text: "Permanent", value: 1 },
    //   { text: "Temporary", value: 2 }
    // ],
    items: [
      {
        contact_person: "Dr Saif Ullah",
        department: "Police Dedpartment KP",
        city: "Mardan"
      },
      {
        contact_person: "Dr Ata Ullah",
        department: "Police Dedpartment ISLAMABAD",
        city: "Peshawar"
      }
    ],
    fields: [
      { key: "city", label: "City" },
      { key: "department", label: "Department" },
      { key: "contact_person", label: "Contact Person" },
      { key: "actions", label: "" }
    ],
    selected: "first"
  }),
  watch: {
    nationality(val) {
      this.openLoading();
      axios
        .get(localStorage.getItem("BASE_PATH") + "/provinces/get/" + val
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.provinceArr = response.data;
        });
    },
    province() {}
  },
  created() {
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/thematics/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.valuesArray = response.data;
      });
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    // Set the initial number of items
    if (
      JSON.parse(localStorage.getItem("currentUser")) != undefined &&
      JSON.parse(localStorage.getItem("currentUser")) != null
    ) {
      this.openLoading();
      axios
        .get(localStorage.getItem("BASE_PATH") + "/districts/get/"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.districtArr = response.data;
        });
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/trainer/get/details/" +
            JSON.parse(localStorage.getItem("currentUser")).id +
            ""

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data) {
            if (response.data.thematic != null) {
              response.data.thematic.forEach(dnr => {
                this.thematicareaSelected.push(dnr.id);
              });
            }
            if (response.data.trainerDetails) {
              if (response.data.trainerDetails.name) {
                this.name = response.data.trainerDetails.name;
              } else if (response.data.trainerDetails.user) {
                this.name = response.data.trainerDetails.user.name;
              }
              if (
                response.data.trainerDetails.cnic != null &&
                response.data.trainerDetails.cnic != ""
              ) {
                // this.whichSelect = 1;
                this.cnincnumber = response.data.trainerDetails.cnic;
              }
              if (
                response.data.trainerDetails.passport != null &&
                response.data.trainerDetails.passport != ""
              ) {
                //this.whichSelect = 0;
                this.passport = response.data.trainerDetails.passport;
              }
              if (response.data.trainerDetails.gender) {
                this.gender = response.data.trainerDetails.gender;
              }
              if (response.data.trainerDetails.languageSkills) {
                this.languagerowArr = JSON.parse(
                  response.data.trainerDetails.languageSkills
                );
              }
              if (response.data.trainerDetails.skills) {
                this.tags = JSON.parse(response.data.trainerDetails.skills);
              }
              if (response.data.trainerDetails.user) {
                if (response.data.trainerDetails.mobile) {
                  this.mobilenumber = response.data.trainerDetails.mobile;
                }
                if (response.data.trainerDetails.email) {
                  this.emailaddress =
                    response.data.trainerDetails.email;
                }
              }
              /* if (response.data.trainerDetails.country_id) {
                this.nationality = response.data.trainerDetails.country_id;
              } */
              if (response.data.trainerDetails.district_id) {
                this.distrct = response.data.trainerDetails.district_id;
              }
              /* if (response.data.trainerDetails.province_id) {
                this.province = response.data.trainerDetails.province_id;
              } */
              if (response.data.trainerDetails.address) {
                this.physicaladdress = response.data.trainerDetails.address;
              }
              if (response.data.trainerDetails.academicqualifications) {
                this.accademicArr = JSON.parse(
                  response.data.trainerDetails.academicqualifications
                );
              }
              if (response.data.trainerDetails.userCertificates) {
                this.certificateArr = JSON.parse(
                  response.data.trainerDetails.userCertificates
                );
              }
              if (response.data.trainerDetails.employeementrecord) {
                this.employeerecordArr = JSON.parse(
                  response.data.trainerDetails.employeementrecord
                );
              }
              if (response.data.trainerDetails.trainingunodc) {
                this.unodcrowArr = JSON.parse(
                  response.data.trainerDetails.trainingunodc
                );
              }
              if (response.data.trainerDetails.trainingother) {
                this.rowArr = JSON.parse(
                  response.data.trainerDetails.trainingother
                );
              }
              if (response.data.trainerDetails.uploadcv) {
                this.uploadfileName = response.data.trainerDetails.uploadcv.substring(
                  33,
                  100
                );
                this.uploadfileurl =
                  localStorage.getItem("BASE_PATH") +
                  "/" +
                  response.data.trainerDetails.uploadcv;
              }
            }
          }
          this.userDetails = response.data;
        });
    }
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/countries/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.countryArr = response.data;
      });
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/provinces/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.provinceArr = response.data;
      });
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/languages/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.languageskillsArr = response.data;
      });
  },
  components: {
    datePicker,
    Selectize,
    "app-navbar": Navbar,
    "app-main-sidebar": mainSidebar,
    VueTagsInput,
    flatPickr
  },

  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    trainerRegistration(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.name) {
        this.inValid.push("Name is required.");
      }
      if (!this.passport) {
        this.inValid.push("Passport is required.");
      }
      if (!this.cnincnumber) {
        this.inValid.push("CNIC type is required.");
      }
      if (!this.gender) {
        this.inValid.push("Gender type is required.");
      }
      if (!this.emailaddress) {
        this.inValid.push("Email is required.");
      }
      if (!this.mobilenumber) {
        this.inValid.push("Mobile Number is required.");
      }
      if (!this.nationality) {
        this.inValid.push("Nationality is required.");
      }
      if (!this.province) {
        this.inValid.push("Province is required.");
      }
      if (!this.distrct) {
        this.inValid.push("District is required.");
      }
      if (!this.physicaladdress) {
        this.inValid.push("Address is required.");
      }

      //For phone number validation
      var phone_no1 = this.mobilenumber;
      if (phone_no1 == null || phone_no1 == undefined) {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
        if (phone_no1.length < 14) {
          this.inValid.push("Must be valid Number, 0345-9992229");
        }
      }
      var cnic_var = this.cnincnumber;
      if (cnic_var == null || cnic_var == undefined) {
        this.inValid.push("Must be valid CNIC, 16101-1114812-3");
      } else {
        cnic_var = cnic_var.replace(/_/g, "");
        if (cnic_var.length < 17) {
          this.inValid.push("Must be valid CNIC, 16101-1114812-3");
        }
      }
      if (this.certificateArr.length > 0) {
        this.certificateArr.forEach(element => {
          var passing_y = element.certificateYear;
          passing_y = passing_y.replace(/_/g, "");
          if (passing_y.length < 4) {
            this.inValid.push("Must be valid YEAR, 2020");
          }
        });
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append(
          "user_id",
          JSON.parse(localStorage.getItem("currentUser")).id
        );
        formData.append("trainerName", this.name);
        formData.append("passport", this.passport);
        formData.append("cnincnumber", this.cnincnumber);
        formData.append("gender", this.gender);
        formData.append("languageSkills", JSON.stringify(this.languagerowArr));
        formData.append(
          "userCertificates",
          JSON.stringify(this.certificateArr)
        );
        formData.append("academicArray", JSON.stringify(this.accademicArr));
        formData.append(
          "employeerecordArr",
          JSON.stringify(this.employeerecordArr)
        );
        formData.append("unodcTrainging", JSON.stringify(this.unodcrowArr));
        formData.append("otherTraining", JSON.stringify(this.rowArr));
        formData.append(
          "thematicareaSelected",
          JSON.stringify(this.thematicareaSelected)
        );
        formData.append("otherskills", JSON.stringify(this.tags));
        formData.append("emailaddress", this.emailaddress);
        formData.append("mobilenumber", this.mobilenumber);
        formData.append("nationality", this.nationality);
        formData.append("province", this.province);
        formData.append("distrct", this.distrct);
        formData.append("physicaladdress", this.physicaladdress);
        this.openLoading();
        axios
          .post(
            localStorage.getItem("BASE_PATH") + "/register/trainer",
            formData
        )
        .then(response => {
          if(response.data.unAuth){
             this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
             this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
            this.closeLoading();
            self.$router.push({ name: "TraineeReg" });
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    addRows() {
      this.rowArr.push({
        otherTrainingName: "",
        otherDate: "",
        otherdepartment: ""
      });
    },
    removeRow: function() {
      this.rowArr.pop();
    },
    addunodcRows() {
      this.unodcrowArr.push({
        unodcTrainingName: "",
        unodcDate: "",
        unodcdepartment: ""
      });
    },
    removeunodcRow: function() {
      this.unodcrowArr.pop();
    },
    addemployeerecordRows() {
      this.employeerecordArr.push({
        emp_organization: "",
        emp_designation: "",
        emp_fromDate: "",
        emp_endDate: ""
      });
    },
    removeemployeerecordRow: function() {
      this.employeerecordArr.pop();
    },
    addaccademicRows() {
      this.accademicArr.push({
        degreename: "",
        degreesubject: "",
        univeristyName: ""
      });
    },
    removeaccademicRow: function() {
      this.accademicArr.pop();
    },
    addcertificateRows() {
      this.certificateArr.push({
        certificateName: "",
        certificateYear: "",
        certificateInstitute: ""
      });
    },
    removecertificateRow: function() {
      this.certificateArr.pop();
    },
    addlanguageRows() {
      this.languagerowArr.push({
        lang: "",
        readlevel: "",
        writelevel: "",
        speaklevel: ""
      });
    },
    removelanguageRow: function() {
      this.languagerowArr.pop();
    },

    successUpload() {
      this.$vs.notify({
        color: "primary",
        title: "Upload Success",
        text: "Your file is uploaded Successfully."
      });
    },
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    }
  }
};
</script>

<style>
.con-vs-tabs .con-slot-tabs {
  /* overflow: scroll !important; */
}
input.form-control.flatpickr-input {
  border: 1px solid #adadad !important;
}
</style>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}

button:focus {
  outline: transparent !important;
  outline: transparent -webkit-focus-ring-color !important;
}

.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.otherMaterial_palceholder {
  margin-top: 16px;
  background: #dedede;
  padding: 10px 0px 10px 0px;
  text-align: center;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #ffffff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.save-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 0px;
}
.previous-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: left;
  margin: 10px 0px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
  width: 100% !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #fff;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
/****  floating-Lable style end ****/
/* Floating label css ends */

.add-btn {
  font-size: 25px !important;
  color: rgba(7, 167, 225, 0.61);
  cursor: pointer;
}
.delete-btn {
  font-size: 25px;
  color: rgba(255, 0, 0, 0.78);
  cursor: pointer;
}
</style>
